import { useQuery } from '@tanstack/react-query';

import PriceParrotService from '~/services/PriceParrotService';

import { chainLpcLppSupplierQueryKeys } from './chainLpcLppSupplierQueryKeys';

export function useGetChainLpcLppSupplierDailyTrend(
  chainName: string | undefined,
  offerBk: string | undefined,
  dateFrom: string | undefined,
  dateTo: string | undefined,
  enabled: boolean,
) {
  return useQuery({
    queryKey: chainLpcLppSupplierQueryKeys.dailyTrend(chainName ?? '', offerBk ?? '', dateFrom ?? '', dateTo ?? ''),
    queryFn: async ({ signal }) => {
      if (!chainName || !offerBk || !dateFrom || !dateTo) {
        throw new Error('Chain LPC-LPP daily trend requires chainName, offerBk, dateFrom, and dateTo');
      }
      const res = await PriceParrotService.getParityTrendChainLpcLppDailyTrend(
        chainName,
        { date_from: dateFrom, date_to: dateTo, offer_bk: offerBk },
        signal,
      );
      return res.data;
    },
    enabled: enabled && Boolean(chainName && offerBk && dateFrom && dateTo),
  });
}
